import { render, staticRenderFns } from "./GenericImage.vue?vue&type=template&id=567fc4fc"
import script from "./GenericImage.vue?vue&type=script&lang=ts"
export * from "./GenericImage.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./GenericImage.vue?vue&type=style&index=0&id=567fc4fc&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports